<template>
  <div class="brandManageBox">
    <div class="titleBox">
      <div class="title">
        <h5>BU管理</h5>
        <button class="addButton" @click="addBuTag">添加BU</button>
      </div>
      <i class="iconfont rightIcon icon-xiangyou1" />
      <div class="title">
        <h5>领域管理</h5>
        <button class="addButton" @click="addFieldTag">添加领域</button>
      </div>
      <i class="iconfont rightIcon icon-xiangyou1" />
      <div class="title">
        <h5>产品管理</h5>
        <button class="addButton" @click="addProductTag">添加产品</button>
      </div>
    </div>
    <div class="selectBox">
      <!-- BU -->
      <div class="BU item">
        <TableTemplate
          :table-loading="tableLoading"
          :column="BUData.column"
          :data="BUData.data"
          :no-pages="true"
          :width="148"
          :is-choose-table="true"
          :table-body-style="{ maxHeight: '425px' }"
          @tableRowEmit="buTableRow"
        >
          <template v-slot:default="slotProps">
            <div v-if="slotProps.item.enabled" class="operatingIn">
              <div class="Strategy-View item" @click.stop="editBuTag(slotProps.item, $event)">
                编辑
              </div>
              <span class="Strategy-View-border" />
              <div
                class="Strategy-edit item"
                @click.stop="
                  showDialog(
                    slotProps.item,
                    {
                      title1: '确定禁用该BU吗？',
                      title2:
                        '（禁用后，所有关联的领域、产品标签均禁用;且若恢复BU后，该BU所有相关的文章需要手动重新发布）',
                    },
                    $event,
                  )
                "
              >
                禁用
              </div>
            </div>
            <div v-else class="operatingIn">
              <div
                class="Strategy-gray-restore item"
                @click.stop="
                  showDialog(slotProps.item, { title1: '确定恢复该BU吗？', title2: '' }, $event)
                "
              >
                恢复
              </div>
            </div>
          </template>
        </TableTemplate>
        <!-- 添加BU -->
        <AddTag
          v-loading="tagLoading"
          :dialog-form-visible="addBUShow"
          :first-title="buContent | buFilter"
          :second-title="'BU名称'"
          :place-holder-text="'请输入BU名称'"
          :init-input-value="buContent"
          @sureBtnEmit="buSureBtnEmit"
          @hideDialog="hideDialog"
        />
      </div>
      <i class="iconfont rightIcon icon-xiangyou1" :style="buId ? '' : { visibility: 'hidden' }" />
      <!-- 领域 -->
      <div class="field item">
        <TableTemplate
          :table-loading="tableLoading"
          :column="fieldData.column"
          :data="fieldData.data"
          :no-pages="true"
          :width="208"
          :is-choose-table="true"
          :table-body-style="{ maxHeight: '425px' }"
          @tableRowEmit="fieldTableRow"
        >
          <template v-slot:default="slotProps">
            <div
              :ref="'field' + slotProps.index"
              class="operatingIn scrollX"
              v-if="slotProps.item.enabled"
            >
              <div class="Strategy-View item" @click.stop="editFieldTag(slotProps.item, $event)">
                编辑
              </div>
              <span class="Strategy-View-border" />
              <div
                class="Strategy-close item"
                @click.stop="
                  showDialog(
                    slotProps.item,
                    {
                      title1: '确定禁用该领域吗？',
                      title2:
                        '（禁用后，所有关联的产品标签均禁用;且若恢复领域后，该领域所有相关的文章需要手动重新发布）',
                    },
                    $event,
                  )
                "
              >
                禁用
              </div>
              <span class="Strategy-View-border" />
              <div
                v-if="slotProps.item.showStatus"
                class="Strategy-show item"
                @click.stop="
                  showDialog(
                    slotProps.item,
                    {
                      title1: '确定隐藏该领域吗？',
                      title2: '（隐藏后，内容在小程序的tab中不显示）',
                    },
                    $event,
                  )
                "
              >
                隐藏
              </div>
              <div
                v-else
                class="Strategy-show item"
                @click.stop="
                  showDialog(slotProps.item, { title1: '确定显示该领域吗？', title2: '' }, $event)
                "
              >
                显示
              </div>
              <span class="Strategy-View-border" />
              <div
                v-if="slotProps.index === 0"
                class="Strategy-up item"
                style="color: #c0c4cc"
                @click.stop
              >
                上移
              </div>
              <div
                v-else
                class="Strategy-up item"
                @click.stop="sortBrandLabel(slotProps.item, slotProps.index, 'up', $event)"
              >
                上移
              </div>
              <span class="Strategy-View-border" />
              <div
                v-if="slotProps.item.notDown || fieldData.data.length - 1 === slotProps.index"
                class="Strategy-edit item"
                style="color: #c0c4cc"
                @click.stop
              >
                下移
              </div>
              <div
                v-else
                class="Strategy-edit item"
                @click.stop="sortBrandLabel(slotProps.item, slotProps.index, 'down', $event)"
              >
                下移
              </div>
            </div>
            <div v-else class="operatingIn">
              <div
                class="Strategy-gray-restore item"
                @click.stop="
                  showDialog(slotProps.item, { title1: '确定恢复该领域吗？', title2: '' }, $event)
                "
              >
                恢复
              </div>
            </div>
            <!-- 左右移动 -->
            <span data-move class="moveButtons" v-if="slotProps.item.enabled">
              <i
                :class="!slotProps.item.isCanLeft ? 'disabled' : null"
                class="iconfont left icon-xiangzuo"
                @click.stop="toLeft('field', slotProps.index, $event)"
              />
              <i
                :class="
                  slotProps.item.isCanRight || slotProps.item.isCanRight == null ? null : 'disabled'
                "
                class="iconfont right icon-xiangyou"
                @click.stop="toRight('field', slotProps.index, $event)"
              />
            </span>
          </template>
        </TableTemplate>
        <!-- 添加领域 -->
        <AddTag
          v-loading="tagLoading"
          :dialog-form-visible="addFieldShow"
          :first-title="fieldContent | fieldFilter"
          :second-title="'领域名称'"
          :third-title="'关联BU'"
          :place-holder-text="'请输入其他分类名称'"
          :options="BUData.data"
          :init-input-value="fieldContent.inputValue"
          :init-select-value="fieldContent.selectValue"
          @sureBtnEmit="fieldSureBtnEmit"
          @hideDialog="hideFieldDialog"
        />
      </div>
      <i class="iconfont rightIcon icon-xiangyou1" :style="buId ? '' : { visibility: 'hidden' }" />
      <!-- 产品线 -->
      <div class="product item">
        <TableTemplate
          :table-loading="tableLoading"
          :column="productData.column"
          :data="productData.data"
          :no-pages="true"
          :width="148"
          :is-choose-table="true"
          :table-body-style="{ maxHeight: '425px' }"
          @tableRowEmit="productTableRow"
        >
          <template v-slot:default="slotProps">
            <div v-if="slotProps.item.enabled" class="operatingIn">
              <div class="Strategy-View item" @click.stop="editProductTag(slotProps.item, $event)">
                编辑
              </div>
              <span class="Strategy-View-border" />
              <div
                class="Strategy-edit item"
                @click.stop="
                  showDialog(
                    slotProps.item,
                    {
                      title1: '确定禁用该产品吗？',
                      title2: '若恢复产品后，该产品所有相关的文章需要手动重新发布',
                    },
                    $event,
                  )
                "
              >
                禁用
              </div>
            </div>
            <div v-else class="operatingIn">
              <div
                class="Strategy-gray-restore item"
                @click.stop="
                  showDialog(slotProps.item, { title1: '确定恢复该产品吗？', title2: '' }, $event)
                "
              >
                恢复
              </div>
            </div>
          </template>
        </TableTemplate>
        <!-- 添加产品 -->
        <AddTag
          v-loading="tagLoading"
          :dialog-form-visible="addProductShow"
          :first-title="productContent | productFilter"
          :second-title="'产品名称'"
          :third-title="'关联领域'"
          :place-holder-text="'请输入其他分类名称'"
          :options="fieldData.data"
          :init-input-value="productContent.inputValue"
          :init-select-value="productContent.selectValue"
          @sureBtnEmit="productSureBtnEmit"
          @hideDialog="hideProductDialog"
        />
      </div>
    </div>
    <DialogComp
      :title1="title1"
      :title2="title2"
      :dialog-visible="dialogVisible"
      @dialogEmit="dialogEmit"
    />
  </div>
</template>
<script>
import { BUData, fieldData, productData, fieldOption } from './field';
import AddTag from '../addTag';
import TableTemplate from '@/components/tableTemplate'; /* 表单公共组件 */
import DialogComp from '@/components/orange-dialog';

const labelTypeMap = new Map([
  [10, 'BUData'],
  [20, 'fieldData'],
  [30, 'productData'],
]);
export default {
  name: 'BrandManagement',
  components: {
    AddTag,
    TableTemplate,
    DialogComp, // 橘色弹窗
  },
  filters: {
    buFilter(value) {
      if (value) {
        return '编辑BU';
      }
      return '添加BU';
    },
    fieldFilter(value) {
      if (value) {
        return '编辑领域';
      }
      return '添加领域';
    },
    productFilter(value) {
      if (value) {
        return '编辑产品';
      }
      return '添加产品';
    },
  },
  data() {
    return {
      fieldOption,
      addBUShow: false /* 添加BU */,
      addFieldShow: false /* 添加领域 */,
      addProductShow: false /* 添加产品 */,
      BUData /* BU数据 */,
      fieldData /* 领域数据 */,
      productData /* 产品数据 */,
      buContent: '', // BU的内容
      fieldContent: '', // 领域的内容
      productContent: '', // 产品的内容
      tableLoading: false,
      tagLoading: false,
      id: '', // 暂存id, 代表编辑, 空是新增
      buId: '', // 暂存buId 表格编辑 禁用列表刷新用
      domainId: '', // 暂存domainId 表格编辑 禁用列表刷新用
      buNode: '', // 保存点击bu表格行的元素节点
      domainNode: '', // 保存点击领域表格行的元素节点
      title1: '确定执行此操作吗',
      title2: '',
      dialogVisible: false,
      itemTemp: '', // 暂存, 启用禁用
    };
  },
  created() {
    this.getAllList();
  },
  methods: {
    // 请求所有列表
    async getAllList() {
      this.buId = '';
      this.domainId = '';
      await this.getBrandList({ labelType: 10 });
      await this.getBrandList({ labelType: 20 });
      await this.getBrandList({ labelType: 30 });
    },
    // 查询品牌标签列表
    async getBrandList(query = {}) {
      this.tableLoading = true;

      try {
        const { data } = await this.$requestData('/api/labelComplex/manager/query', query);
        if (data.code === 0) {
          if (query.buId) {
            // 如果是选择BU列表行, 产品需要清空
            this[labelTypeMap.get(30)].data = [];
          }
          this[labelTypeMap.get(query.labelType)].data = []; // 清空当前列表

          // 领域管理最后一行不能下移 判断下一行如果是禁用,上一行就是最后一行所以不能下移(判断不是第一行)
          if (query.labelType === 20) {
            for (let index = 0; index < data.data.length; index++) {
              if (data.data[index].enabled === 0 && index > 0) {
                data.data[index - 1].notDown = true;
                break;
              }
            }
          }

          data.data.forEach((e) => {
            if (e.labelType === 10) {
              e.enabledName = e.enabled ? '启用' : '禁用';
            }
            console.log(2);
            this[labelTypeMap.get(e.labelType)].data.push(e);
          });
        }
      } catch (error) {
        console.log(error);
      }

      this.tableLoading = false;
    },
    // bu列表行点击回调 更新领域列表内容 (暂存buId值, 给领域编辑禁用这些操作使用)
    async buTableRow({ item, curTableRow }) {
      this.buId = item.id;
      this.domainId = '';
      this.buNode = curTableRow; // 保存点击表格行的元素节点
      await this.getBrandList({ buId: item.id, labelType: 20 });
      await this.getBrandList({ buId: item.id, labelType: 30 });

      this.activeScrollTop('buId');
    },
    // 领域列表行点击回调 更新产品列表内容 (暂存domainId值, 给产品编辑禁用这些操作使用, 也要暂存buId,因为有可能首次就点击领域)
    async fieldTableRow({ item, curTableRow }) {
      this.buId = item.buId;
      this.domainId = item.id;
      this.domainNode = curTableRow; // 保存点击表格行的元素节点
      // 数据驱动 高亮bu列表关联的标签
      const data1 = this.BUData.data;
      for (let i = 0, ilen = data1.length; i < ilen; i++) {
        if (item.buId === data1[i].id) {
          data1[i].active = true;
        } else {
          data1[i].active = false;
        }
      }

      this.$set(this.BUData.data, data1);
      this.BUData.data = this.BUData.data.reverse().reverse();

      await this.getBrandList({ domainId: item.id, labelType: 30 });

      this.activeScrollTop('domainId');
    },
    // 产品行回调
    productTableRow({ item }) {
      this.buId = item.buId;
      this.domainId = item.domainId;

      // 数据驱动 高亮bu列表关联的标签
      const data1 = this.BUData.data;
      for (let i = 0, ilen = data1.length; i < ilen; i++) {
        if (item.buId === data1[i].id) {
          data1[i].active = true;
        } else {
          data1[i].active = false;
        }
      }

      this.$set(this.BUData.data, data1);

      // 数据驱动 高亮领域列表关联的标签
      const data2 = this.fieldData.data;
      for (let i = 0, ilen = data2.length; i < ilen; i++) {
        if (item.domainId === data2[i].id) {
          data2[i].active = true;
        } else {
          data2[i].active = false;
        }
      }

      this.$set(this.fieldData.data, data2);
      this.fieldData.data = this.fieldData.data.reverse().reverse();

      this.activeScrollTop();
    },
    // 滚动到对应行
    activeScrollTop(curTable = '') {
      setTimeout(() => {
        const threeActiveline = document.getElementsByClassName(
          'release-Strategy-normal table-line-active',
        );
        try {
          if (curTable === 'buId') {
            threeActiveline[1] ? (threeActiveline[1].parentNode.parentNode.scrollTop = 0) : '';
            threeActiveline[2] ? (threeActiveline[2].parentNode.parentNode.scrollTop = 0) : '';
          } else if (curTable === 'domainId') {
            threeActiveline[0].parentNode.parentNode.scrollTop = threeActiveline[0].offsetTop;
            threeActiveline[2] ? (threeActiveline[2].parentNode.parentNode.scrollTop = 0) : '';
          } else {
            threeActiveline[0].parentNode.parentNode.scrollTop = threeActiveline[0].offsetTop - 48;
            threeActiveline[1].parentNode.parentNode.scrollTop = threeActiveline[1].offsetTop - 48;
          }
        } catch (error) {
          console.log(error);
        }
        // for (const iterator of threeActiveline) {
        //     iterator.parentNode.parentNode.scrollTop = iterator.offsetTop - 48
        // }
      }, 0);
    },
    // BU创建
    addBuTag() {
      this.addBUShow = true;
      this.id = '';
      this.buContent = '';
    },
    // BU编辑
    editBuTag(item) {
      // stopPropagation($event)
      this.addBUShow = true;
      this.id = item.id;
      this.buContent = item.labelName;
    },
    // 领域创建
    addFieldTag() {
      this.addFieldShow = true;
      this.id = '';
      this.fieldContent = '';
    },
    // 领域编辑
    editFieldTag(item) {
      // stopPropagation($event)
      this.addFieldShow = true;
      this.id = item.id;
      this.fieldContent = {
        inputValue: item.labelName,
        selectValue: item.buId,
      };
    },
    // 产品创建
    addProductTag() {
      this.addProductShow = true;
      this.id = '';
      this.productContent = '';
    },
    // 产品编辑
    editProductTag(item) {
      // stopPropagation($event)
      this.addProductShow = true;
      this.id = item.id;
      this.productContent = {
        inputValue: item.labelName,
        selectValue: item.domainId,
      };
    },
    // Bu的弹框确认回调
    buSureBtnEmit(e) {
      this.addEditBrandLabel({ labelName: e.inputValue, labelType: 10 });
    },
    // 领域的弹框确认回调
    fieldSureBtnEmit(e) {
      this.addEditBrandLabel({
        labelName: e.inputValue,
        buId: e.selectValue,
        labelType: 20,
      });
    },
    // 产品的弹框确认回调
    productSureBtnEmit(e) {
      this.addEditBrandLabel({
        labelName: e.inputValue,
        domainId: e.selectValue,
        labelType: 30,
        buId: e.buId,
      });
    },
    /**
     * 创建-编辑品牌标签 公用
     * this.addEditBrandLabel({ 'labelName': '标签名称', labelType: 10/20/30 })
     */
    async addEditBrandLabel(e) {
      this.tagLoading = true;
      const query = {};
      let res = {};
      if (this.id) {
        // 编辑
        query.id = this.id;
        for (const [key, val] of Object.entries(e)) {
          query[key] = val;
        }
        res = await this.$requestData('/api/labelComplex/manager/modifyLabelComplex', query);
      } else {
        // 创建
        for (const [key, val] of Object.entries(e)) {
          query[key] = val;
        }
        res = await this.$requestData('/api/labelComplex/manager/saveLabelComplex', query);
      }
      try {
        if (res.data.code === 0) {
          this.id ? this.$message.success('编辑成功') : this.$message.success('添加成功');
          this.hideDialog();
          this.hideFieldDialog();
          this.hideProductDialog();
          this.buContent = '';
          this.fieldContent = '';
          this.productContent = '';
          switch (
            e.labelType // 刷新相应的表, 比如领域创建了, 就刷新领域的表(需要根据bu表有没有点击选中, 有选中一个选项, 领域表查的时候就要查这个选项下的)
          ) {
            case 20:
              this.getBrandList({
                buId: this.buId,
                labelType: 20,
              });
              break;
            case 30:
              this.getBrandList({
                domainId: this.domainId,
                labelType: 30,
              });
              break;
            default:
              this.getAllList();
              break;
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.tagLoading = false;
    },
    // 启用禁用 公用
    async toggleBrandLabel(item) {
      try {
        const { data } = await this.$requestData(
          '/api/labelComplex/manager/revDisableLabelComplex',
          {
            id: item.id,
            enable: item.enabled ? 0 : 1,
          },
        );
        if (data.code === 0) {
          this.$message.success('修改成功');
          if (item.buId && item.domainId) {
            this.getBrandList({
              buId: this.buId,
              domainId: this.domainId,
              labelType: 30,
            });
          } else if (item.buId) {
            this.getBrandList({ buId: this.buId, labelType: 20 });
          } else {
            this.getAllList();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 领域隐藏显示
    async visibleShowLabel(item) {
      // stopPropagation($event)
      try {
        const { data } = await this.$requestData(
          '/api/labelComplex/manager/hiddenDisplayLabelComplex',
          {
            id: item.id,
            showStatus: item.showStatus ? 0 : 1,
          },
        );
        if (data.code === 0) {
          this.$message.success('修改成功');
          this.getBrandList({ buId: this.buId, labelType: 20 });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 领域排序
    async sortBrandLabel(item, index, direction) {
      // stopPropagation($event)
      const query = {
        id: item.id,
        buId: this.buId,
        labelSort: direction === 'up' ? 1 : 0,
      };
      try {
        const { data } = await this.$requestData(
          '/api/labelComplex/manager/reSortLabelComplex',
          query,
        );
        if (data.code === 0) {
          this.$message.success('排序成功');
          this.getBrandList({ buId: this.buId, labelType: 20 });
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 唤出弹窗
    showDialog(item, dialogTitle, $event) {
      // stopPropagation($event)
      this.dialogVisible = true;
      this.itemTemp = item;
      this.$eventTemp = $event;
      this.title1 = dialogTitle.title1;
      this.title2 = dialogTitle.title2;
    },
    // 弹窗回调 - e: 关闭false 确定true
    dialogEmit(e) {
      if (!e) {
        this.dialogVisible = false;
        return false;
      }
      this.dialogVisible = false;
      const clickTxt = this.$eventTemp.target.innerText;
      if (clickTxt === '显示' || clickTxt === '隐藏') {
        e ? this.visibleShowLabel(this.itemTemp) : '';
      } else {
        e ? this.toggleBrandLabel(this.itemTemp) : '';
      }
    },

    // 编辑 bu弹窗
    hideDialog() {
      this.addBUShow = false;
    },
    // 编辑 领域弹窗
    hideFieldDialog() {
      this.addFieldShow = false;
    },
    // 编辑 产品弹窗
    hideProductDialog() {
      this.addProductShow = false;
    },
    /* 向左移动 */
    toLeft(ref, index) {
      let type;
      if (ref == 'field') {
        type = 'fieldData';
      } else {
        return false;
      }
      const data = JSON.parse(JSON.stringify(this[type].data));
      const dom = this.$refs[ref + index];
      if (dom.scrollLeft > 0) {
        if (dom.scrollLeft - 40 < 0) {
          dom.scrollLeft = 0;
          const item = data[index];
          item.isCanRight = true;
          item.isCanLeft = false;
          data.splice(index, 1, item);
        } else {
          dom.scrollLeft = dom.scrollLeft - 40;
          const item = data[index];
          item.isCanRight = true;
          item.isCanLeft = true;
          data.splice(index, 1, item);
        }
      } else {
        dom.scrollLeft = 0;
        const item = data[index];
        item.isCanRight = true;
        item.isCanLeft = false;
        data.splice(index, 1, item);
      }
      this[type].data = data;
    },
    /* 向右移动 */
    toRight(ref, index) {
      // stopPropagation($event)
      let type;
      if (ref == 'field') {
        type = 'fieldData';
      } else {
        return false;
      }
      const data = JSON.parse(JSON.stringify(this[type].data));
      const dom = this.$refs[ref + index];
      const parentWidth = this.$refs[ref + index].parentElement.offsetWidth;
      const length = Math.abs(dom.scrollWidth + 40 - parentWidth);
      if (dom.scrollLeft < length) {
        if (dom.scrollLeft + 40 > length) {
          dom.scrollLeft = length;
          const item = data[index];
          item.isCanRight = false;
          item.isCanLeft = true;
          data.splice(index, 1, item);
        } else {
          dom.scrollLeft = dom.scrollLeft + 40;
          const item = data[index];
          item.isCanRight = true;
          item.isCanLeft = true;
          data.splice(index, 1, item);
        }
      } else {
        dom.scrollLeft = length;
        const item = this[type].data[index];
        item.isCanRight = false;
        item.isCanLeft = true;
        data.splice(index, 1, item);
      }
      this[type].data = data;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
.customClass {
  background-color: yellow;
}
</style>
